import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Cotizacion from './pages/Cotizacion';
import Shopping from './pages/Shopping';
import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import { useCart } from 'react-use-cart';

function App() {
  const { cartTotal, metadata, updateCartMetadata } = useCart();
  const { loading, setLoading } = useState(true);
  const amount = cartTotal;

  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    const postData = async () => {
      try {

        const response = await fetch('https://api-trbk.marturica.workers.dev/api/trbk', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: amount > 0 ? amount : '10',
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json()
        console.log('aca', data)
        setLoading(false);
        updateCartMetadata({ token: "data.token" })
        console.log('aca2', metadata)

        //updateCartMetadata({url:data.url})
        
      } catch (err) {
        //setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {

      }
    }

    window.addEventListener('load', () => {
      aos_init();
      postData();
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);


  // let buyOrder = "O-" + Math.floor(Math.random() * 10000) + 1;
  // let sessionId = "S-" + Math.floor(Math.random() * 10000) + 1;
  // let amount = Math.floor(Math.random() * 1000) + 1001;
  // let returnUrl = "http://localhost:3000";

  // const createResponse = async () => await (new WebpayPlus.Transaction({
  //   environment: Environment.Integration,
  //   commerceCode: process.env.REACT_APP_WPP_CC,
  //   apiKey: process.env.REACT_APP_WPP_KEY
  // })).create(
  //   buyOrder,
  //   sessionId,
  //   amount,
  //   returnUrl
  // );

  // createResponse()
  //   .then(function (response) {
  //     return response.json();
  //   })
  //   .then(function (result) {
  //     console.log(result);
  //   })
  //   .catch(function (error) {
  //     console.log('Request failed', error);
  //   });


  useDocTitle("Norembal | Transportes , Materiales de Embalaje");

  return (
    <>
    {loading && <p>Cargando</p>}
    {!loading &&
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home  />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/cotizacion" element={<Cotizacion />} />
            <Route path="/ventamateriales" element={<Shopping />} />
          </Routes>
        </ScrollToTop>
      </Router>}
    </>
  );
}


export default App;
